/**
 * iter-263 — useMarketplacePreview hook.
 *
 * Subscribes to the singleton marketplacePreviewPlayer and returns
 * pack-scoped state + handlers for a StemPackCard. Each card sees its
 * own view of the global player ("is the global player playing ME?").
 */
import { useEffect, useMemo, useState } from "react";
import player, { pickPreviewStem } from "@/lib/marketplacePreviewPlayer";

export default function useMarketplacePreview(pack) {
  const [snap, setSnap] = useState(() => player.getState());

  useEffect(() => {
    const unsub = player.subscribe(setSnap);
    return unsub;
  }, []);

  const previewStem = useMemo(() => pickPreviewStem(pack?.stems || []), [pack?.pack_id, pack?.stems]); // eslint-disable-line react-hooks/exhaustive-deps

  const isMine = snap.packId === pack?.pack_id;
  const status = isMine ? snap.status : "idle";
  const progress = isMine ? snap.progress : 0;

  const toggle = () => {
    if (!previewStem) return;
    player.toggle(pack.pack_id, previewStem.name, previewStem.url);
  };

  const stop = () => player.stop(pack.pack_id);

  return {
    previewStem,
    canPreview: !!previewStem,
    status,         // 'idle' | 'loading' | 'playing' | 'error'
    progress,       // 0..1 (only when status === 'playing')
    isMine,         // does this pack own the player right now?
    toggle,
    stop,
  };
}
